export default function initCheckout() : void {
    // const $container = document.querySelector<HTMLElement>('woocommerce-checkout.checkout');

    document.addEventListener('DOMContentLoaded', () => {
        if(!document.querySelector('form.woocommerce-checkout')) {
            return;
        }
        const submitButton = document.getElementById('register-user');
        
        wrapElements(ids);
        intervertirCiviliteFirstname();
        
        hasProfile = document.querySelector('.woocommerce-billing-fields')!.classList.contains('has_profile');
        isPayment = document.querySelector('.woocommerce-billing-fields')!.classList.contains('is_payment');

        const WC_Checkout_Form = document.querySelector('form.woocommerce-checkout') as HTMLFormElement;
        const radiosTypeInscription = document.querySelectorAll('input[name="type"]');
        const billingFields = document.querySelector('.woocommerce-billing-fields') as HTMLElement;

        // On change d'URL
        radiosTypeInscription.forEach((radio) => {
            radio.addEventListener('click', (event) => {
                let input = event.target as HTMLInputElement;
                
                if (input.value) {
                    let url = WC_Checkout_Form.action + '?type=' + input.value;
                    location.href = url;
                }
            });
        });

        const searchButton = document.getElementById('search-siret-btn');

        if (searchButton) {
            searchButton.addEventListener('click', (event) => {
                event.preventDefault();
                getInfoEntreprise();
            });
        }

        const buttons = document.querySelectorAll('.checkout-btn-submit');

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                
                const parent = button.parentNode!.parentNode as HTMLElement;
                const currentInput = parent.querySelector('.input-text') as HTMLInputElement;
                validateInput(currentInput);
            });
        });


        
        if (WC_Checkout_Form) {
            WC_Checkout_Form.addEventListener('submit', (event) => {
                event.preventDefault();
            });
        }

        if (submitButton) {
            submitButton.addEventListener('click', async (event) => {
                event.preventDefault();
                // Sélectionnez tous les champs de formulaire dans le formulaire
                const WC_Checkout_Form = document.querySelector('form.woocommerce-checkout') as HTMLFormElement;
                // const form = document.getElementById('monFormulaire') as HTMLFormElement;
                const elements = WC_Checkout_Form.querySelectorAll('input, select, textarea');

                // Créez un objet pour stocker les données du formulaire
                const formData: any = {};

                // Parcourez les éléments récupérés et ajoutez-les à l'objet formData
                elements.forEach(element => {
                    if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement) {
                        if(element.type == 'radio') {
                            if("checked" in element && element.checked) {
                                formData[element.name] = element.value;
                            }
                        } else {
                            formData[element.name] = element.value;
                        }
                    }
                });

                formData.action = 'update_user_info';

                try {
                    const xhr = new XMLHttpRequest();
                    const ajaxURL = window.location.origin + '/wp-admin/admin-ajax.php';
                    xhr.open('POST', ajaxURL, true);
                    xhr.setRequestHeader('Accept', 'application/json');
                    /// xhr.setRequestHeader('Authorization', `Bearer ${token}`);

                    xhr.onreadystatechange = function () {
                        // console.log(xhr);
                        const errorList = document.querySelector('#register-user-errors ul') as HTMLUListElement;
                        const errorListWrapper = document.querySelector('#register-user-errors') as HTMLUListElement;
                        errorListWrapper.style.display = 'none';
                        if (xhr.readyState === XMLHttpRequest.DONE) {
                            const responseData = JSON.parse(xhr.responseText);
                            if (responseData.success) {
                                // window.location.href = 'votre-url-de-redirection';
                                gotoPayment();
                            } else {
                                errorList.innerHTML = '';
                                errorListWrapper.style.display = 'block';
                                for (const key in responseData.data) {
                                    if (Object.prototype.hasOwnProperty.call(responseData.data, key)) {
                                        const errorMessage = responseData.data[key];
                                        if (errorMessage) {
                                            const listItem = document.createElement('li');
                                            listItem.textContent = errorMessage;
                                            errorList.appendChild(listItem);
                                        }
                                    }
                                }
                            }
                        }
                    };

                    xhr.send(new URLSearchParams(formData as any));
                    // console.log(formData);

                    /*if (responseData.success) {
                        // window.location.href = 'votre-url-de-redirection';
                    } else {
                        console.error('Erreur lors de l\'enregistrement :', responseData.error);
                    }*/
                } catch (error) {
                    console.error('Erreur lors de la requête AJAX :', error);
                }
            });
        }
    });

}

interface Ids {
    [key: string]: string[];
}

let hasProfile = false;
let isDialogBoxReady = false;
let isPayment = false;

const siretInput = document.getElementById("before_checkout_billing_form_numero_de_siret") as HTMLInputElement;
const siretErrorText = document.createElement("span");
siretErrorText.className = "error-text";

const ids: Ids = {
    numero_de_siret: ['before_checkout_billing_form_numero_de_siret_field', 'before_checkout_billing_form_info_numero_siret_field'],
    tva_intracommunautaire: ['before_checkout_billing_form_tva_intracommunautaire_field', 'before_checkout_billing_form_info_tva_intracommunautaire_field'],
    autre_pays_tva: ['before_checkout_billing_form_autre_pays_tva__field', 'before_checkout_billing_form_info_autre_pays_tva_field'],
    autre_pays_identification: ['before_checkout_billing_form_autre_pays_identification_field', 'before_checkout_billing_form_info_autre_pays_identification_field'],
}

const wrapElements = (ids: { [key: string]: string[] }) => {
    Object.entries(ids).forEach(([wrapperId, elementIds]) => {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.id = wrapperId;
        wrapperDiv.className = 'dialog-box';

        elementIds.forEach((elementId, index) => {
            const element = document.getElementById(elementId);
            if (element) {
                if (index === 0) { // Si c'est le premier élément du tableau
                    element.parentNode!.insertBefore(wrapperDiv, element);
                }
                wrapperDiv.appendChild(element);
            }
        });
    });
    
    setInterval(cacherDivSiEnfantsCaches, 300, ids);

    /*const radios = document.querySelectorAll('.input-radio');
    radios.forEach(radio => {
        radio.addEventListener('click', () => {
            setTimeout(cacherDivSiEnfantsCaches, 200, ids);
        });
    })*/
};

const cacherDivSiEnfantsCaches = (ids: Ids) => {
    
    if (hasProfile) {
        const $radioFrance = document.getElementById('before_checkout_billing_form_ou_votre_entite_societe_association_organisation_est_elle_officiellement_enregistree__France');
        const franceEvent = new Event('change', { bubbles: true });
        $radioFrance!.dispatchEvent(franceEvent);
    }
    Object.keys(ids).forEach(wrapperId => {
        const wrapperDiv = document.getElementById(wrapperId);
        const elementIds = ids[wrapperId];
        const tousEnfantsCaches = elementIds.every(elementId => {
            const element = document.getElementById(elementId);
            const result = element && window.getComputedStyle(element).display === 'none';
            if(result) {
                isDialogBoxReady = true;
            }
            return result;
        });

        if (wrapperDiv) {
            if (tousEnfantsCaches) {
                wrapperDiv!.classList.remove('active');
            } else {
                wrapperDiv!.classList.add('active');
            }
        }
    });

    if(isDialogBoxReady && !isPayment) {
        const $billingForm = document.querySelector('.woocommerce-billing-fields')! as HTMLElement;
        $billingForm.style.display = 'block';
    }
};

const intervertirCiviliteFirstname = () => {
    const firstNameField = document.getElementById('billing_first_name_field')!;
    const civiliteField = document.getElementById('billing_civilite_field')!;

    const parentElement = firstNameField.parentElement;

    // console.log(firstNameField, civiliteField, parentElement);
    parentElement!.insertBefore(civiliteField, firstNameField);

    setTimeout(() => {
        parentElement!.insertBefore(civiliteField, firstNameField);
    }, 100);
}

function getAccessTokenFromCookie(): string | null {
    const cookieName = 'siret_access_token';
    const cookieValue = document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith(`${cookieName}=`));

    if (cookieValue) {
        return cookieValue.split('=')[1];
    } else {
        return null;
    }
}


const getInfoEntreprise = () => {

    const siretToQuery = siretInput.value;
    siretErrorText.style.display = 'none';
    // let siretToQuery = '';//'30864739500059';
    const token = getAccessTokenFromCookie();

    const apiUrl = 'https://api.insee.fr/entreprises/sirene/V3.11/siret';

    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${apiUrl}/${siretToQuery}`, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            handleSiretQueryResponse(xhr);
        }
    };

    xhr.send();
}

const handleSiretQueryResponse = (xhr: XMLHttpRequest) => {

    if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        
        const entite = {
            name: response.etablissement.uniteLegale.denominationUniteLegale,
            address: response.etablissement.adresseEtablissement.numeroVoieEtablissement + ' ' + response.etablissement.adresseEtablissement.typeVoieEtablissement + ' ' + response.etablissement.adresseEtablissement.libelleVoieEtablissement,
            postalCode: response.etablissement.adresseEtablissement.codePostalEtablissement,
            city: response.etablissement.adresseEtablissement.libelleCommuneEtablissement,
            country: 'FR'
        }

        // const billingFieldWrapper = document.querySelector('.woocommerce-billing-fields__field-wrapper') as HTMLElement;
        const billingCompanyField = document.getElementById('billing_company') as HTMLInputElement;
        const billingAddressField = document.getElementById('billing_address_1') as HTMLInputElement;
        const billingPostcodeField = document.getElementById('billing_postcode') as HTMLInputElement;
        const billingCityFiel = document.getElementById('billing_city') as HTMLSelectElement;

        billingCompanyField.value = entite.name;
        billingAddressField.value = entite.address;
        // console.log(billingAddressField.value);
        billingPostcodeField.value = entite.postalCode;
        billingCityFiel.value = entite.city;
        showBillingField();
    } else {
        siretErrorText.textContent = "Veuillez vérifier votre numero de SIRET";
        siretErrorText.style.display = 'block';

        // Append error message after the input element
        if(siretInput && siretInput.parentNode) {
            siretInput.parentNode.insertBefore(siretErrorText, siretInput.nextSibling);
        }
    }
};

const showBillingField = () => {
    const billingFieldWrapper = document.querySelector('.woocommerce-billing-fields__field-wrapper') as HTMLElement;
    const submitButton = document.getElementById('register-user');
    billingFieldWrapper!.style.display = 'block';
    submitButton!.style.display = 'flex';
}


const isValidValue = (value: any): boolean => {
    if (value === null || value === undefined) {
        return false;
    }

    const trimmedValue = value.trim();
    if (typeof trimmedValue !== 'string' || trimmedValue === '') {
        return false;
    }

    const regex = /^[a-zA-Z0-9]*$/;
    return regex.test(trimmedValue);
}

const validateInput = (input: HTMLInputElement) => {
    const value = input.value;
    const errorText = input.parentNode!.querySelector('.error-text');

    if (errorText) {
        input.parentNode!.removeChild(errorText);
    }

    if (isValidValue(value)) {
        showBillingField()
    } else {
        const errorText = document.createElement("span");
        errorText.className = 'error-text';
        input.parentNode!.insertBefore(errorText,input.nextSibling);
        errorText.textContent = "Veuillez entrer une valeur valide";
    }
}

const gotoPayment = () => {
    const WC_Checkout_Form = document.querySelector('form.woocommerce-checkout') as HTMLFormElement;
    window.location.href = WC_Checkout_Form.action + '?payment';
}